import semver from 'semver';

import { Connection, OrgType } from 'src/ui/graph/types';
import { useProfile } from 'src/ui/hooks/connection';
import { useEndpointVersion } from 'src/ui/hooks/endpoint';
import { isPortalEnabled } from 'src/ui/utils/features';

interface SduSupportContext {
  connection: Connection;
  isPortalEnabled: boolean;
  isStardogEmployee: boolean;
  version: string | null;
}

export const isSduSupportedForConnection = ({
  connection,
  isPortalEnabled: portalEnabled,
  isStardogEmployee,
  version,
}: SduSupportContext): boolean => {
  if (!version || !semver.gte(version, '12.0.0')) {
    return false;
  }
  const isCloudOrFree = connection.isStardogFree || connection.isStardogCloud;
  const isCloudOwner =
    isCloudOrFree && connection.cloud?.owner?.username === connection.username;
  const isPublicOrgConnection =
    isCloudOrFree &&
    (connection.organization?.orgType === OrgType.Public ||
      connection.access?.organization?.orgType === OrgType.Public);
  return (
    isCloudOwner || isPublicOrgConnection || !portalEnabled || isStardogEmployee
  );
};

export const useIsSduSupported = (connection: Connection): boolean => {
  const { data: profileData } = useProfile();
  const version = useEndpointVersion(connection);
  return isSduSupportedForConnection({
    connection,
    isPortalEnabled: isPortalEnabled(),
    isStardogEmployee: profileData?.profile?.is_staff === true,
    version,
  });
};
